import { render, staticRenderFns } from "./PersonDataDetail.vue?vue&type=template&id=6adf3fd3&scoped=true&"
import script from "./PersonDataDetail.vue?vue&type=script&lang=js&"
export * from "./PersonDataDetail.vue?vue&type=script&lang=js&"
import style0 from "./PersonDataDetail.vue?vue&type=style&index=0&id=6adf3fd3&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adf3fd3",
  null
  
)

export default component.exports